import api from "../../api/account";

// initial state
const state = {
  id: undefined,
  name: "",
  email: "",
  i18n: undefined,
  safe: undefined,
  contact: undefined,
  preferences: undefined,
  transfer: undefined,
  miscellaneous: undefined,
  routes: undefined,
  projectsCount: 0,
  refillsCount: 0,
  user: null,
};

const actions = {
  updateSafe({ commit }) {
    api.updateSafe(({ data }) => {
      commit("setSafe", data);
    });
  },
};

const mutations = {
  // new way to go
  setUser(state, user) {
    state.user = user;
  },
  // old dirty stuff from previous developer
  setI18n(state, i18n) {
    state.i18n = i18n;
  },
  setSafe(state, safe) {
    state.safe = safe;
  },
  setUsername(state, name) {
    state.name = name;
  },
  setContact(state, contact) {
    state.contact = contact;
  },
  updateContact(state, contact) {
    state.contact = { ...state.contact, ...contact };
  },
  setPreferences(state, preferences) {
    state.preferences = preferences;
  },
  setUserActivity(state, activity) {
    state.user_activity = activity;
  },
  setTransfer(state, transfer) {
    state.transfer = transfer;
  },
  setMiscellaneous(state, data) {
    state.miscellaneous = data;
  },
  setId(state, id) {
    state.id = id;
  },
  setRoutes(state, routes) {
    state.routes = routes;
  },
  setProjectsCount(state, count) {
    state.projectsCount = count;
  },
  increaseProjectsCount(state) {
    state.projectsCount += 1;
    this.commit("dashboard/increaseProjectsCount");
  },
  decreaseProjectsCount(state) {
    state.projectsCount -= 1;
  },
  setRefillsCount(state, count) {
    state.refillsCount = count;
  },
  increaseRefillsCount(state) {
    state.refillsCount += 1;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
